import moment from 'moment';

// ---------------------------------------------------------------------------
// Exportação CSV das abas de uso, gerada NO NAVEGADOR a partir do que os endpoints já devolvem.
//   - Separador ';' + BOM UTF-8 + CRLF: abre direto no Excel em pt-BR com acentos certos.
//   - Proteção contra fórmula: célula que começa com = + - @ (ou tab/CR) ganha apóstrofo. Dado do histórico (rota, user agent,
//     e-mail tentado) vem de fora do sistema; sem isso, um valor malicioso viraria fórmula na máquina do auditor.
//   - MAX_EXPORT_ROWS: teto declarado na tela. As listas paginadas são buscadas página a página (100 por vez) até o teto —
//     os endpoints do Reports têm limite de 30 requisições/minuto por usuário; 10 páginas cabem com folga.
//     Para volumes maiores existe a exportação por e-mail da Linha do tempo.
// ---------------------------------------------------------------------------

export const MAX_EXPORT_ROWS = 1000;
const PAGE = 100;

const cell = (v) => {
  if (v === null || v === undefined) return '';
  let s = typeof v === 'object' ? JSON.stringify(v) : String(v);
  if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return /[";\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

// columns: [{ header, value: (row) => any }]
export function toCsv(columns, rows) {
  const lines = [columns.map((c) => cell(c.header)).join(';')];
  rows.forEach((r) => lines.push(columns.map((c) => cell(c.value(r))).join(';')));
  return `﻿${lines.join('\r\n')}\r\n`;
}

export function downloadCsv(filename, text) {
  const blob = new Blob([text], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// fetchPage(page, pageSize) → Promise<{ data: [], count }>. Sequencial (uma página por vez), para no teto, no fim dos dados
// ou em página vazia. Devolve { rows, total, truncated }.
export function fetchAllPages(fetchPage, maxRows = MAX_EXPORT_ROWS) {
  const rows = [];
  const step = (page, total) => fetchPage(page, PAGE).then((r) => {
    const data = (r && r.data) || [];
    const count = Number(r && r.count) || total || 0;
    data.forEach((x) => { if (rows.length < maxRows) rows.push(x); });
    const more = data.length === PAGE && rows.length < maxRows && (count === 0 || rows.length < count);
    return more ? step(page + 1, count) : { rows, total: count || rows.length, truncated: (count || rows.length) > rows.length };
  });
  return step(1, 0);
}

export const csvFileName = (tab) => `uso-${tab}-${moment().format('YYYYMMDD-HHmmss')}.csv`;

const when = (d) => (d ? moment(d).format('YYYY-MM-DD HH:mm:ss.SSS') : '');
const origin = (r) => (r.screenVisitId ? 'tela do sistema' : (/^Mozilla\//i.test(String(r.userAgent || '')) && !/powershell/i.test(String(r.userAgent || '')) ? 'navegador, sem tela' : 'direto na API'));

// Colunas padrão de uma LINHA DE EVENTO (linha do tempo, recusas, erros, logins, acessos a um registro, painéis de requisições).
export const EVENT_COLUMNS = [
  { header: 'quando (hora local do contratante)', value: (r) => when(r.occurredAt) },
  { header: 'usuario_id', value: (r) => r.userId },
  { header: 'usuario', value: (r) => r.userName },
  { header: 'email', value: (r) => r.userEmail },
  { header: 'identidade', value: (r) => r.userKind },
  { header: 'acao', value: (r) => r.actionKind },
  { header: 'api', value: (r) => r.api },
  { header: 'metodo', value: (r) => r.httpMethod },
  { header: 'rota', value: (r) => r.route },
  { header: 'caminho', value: (r) => r.path },
  { header: 'tela', value: (r) => r.screenRoute || r.screen },
  { header: 'entidade', value: (r) => r.entityType },
  { header: 'entidade_id', value: (r) => r.entityId },
  { header: 'status', value: (r) => r.statusCode },
  { header: 'duracao_ms', value: (r) => r.durationMs },
  { header: 'ip', value: (r) => r.ip },
  { header: 'origem', value: (r) => origin(r) },
  { header: 'cliente (user agent)', value: (r) => r.userAgent },
  { header: 'request_id', value: (r) => r.requestId },
  { header: 'detalhes', value: (r) => (r.details ? JSON.stringify(r.details) : '') },
];
